import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import Navbar from './Navbar';
import Footer from '../Footer/Footer';
import ChatBot from '../chatbot/ChatBot';
import { ordersApi } from '../../services/api/orders.api';

const OverdueModal = ({ data, onClose }) => {
  return ReactDOM.createPortal(
    <>
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 backdrop-blur-sm" />
      <div className="fixed z-50 inset-0" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <div className="flex items-center justify-center min-h-screen p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl w-full max-w-md relative p-6">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-14 w-14 rounded-full bg-amber-100 dark:bg-amber-900/30 mb-4">
                <svg className="h-7 w-7 text-amber-600 dark:text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              {data.blocked ? (
                <>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">تم إغلاق الدورة</h3>
                  {data.course_name && (
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                      الدورة: <span className="font-medium">{data.course_name}</span>
                    </p>
                  )}
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                    تم تجاوز فترة السماح. يرجى سداد القسط لإعادة فتح الدورة.
                  </p>
                </>
              ) : (
                <>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">تنبيه بوجود قسط متأخر</h3>
                  {data.course_name && (
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                      الدورة: <span className="font-medium">{data.course_name}</span>
                    </p>
                  )}
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                    تم منحك 24 ساعة فترة سماح لسداد القسط. يرجى السداد قبل انتهاء المدة لتجنب إغلاق الدورة.
                  </p>
                </>
              )}
              {data.blocked ? (
                <a
                  href={`/installment-details/${data.order_id}`}
                  className="block w-full px-5 py-2.5 text-sm font-medium text-center text-white bg-primary-600 rounded-xl hover:bg-primary-700 transition-colors"
                >
                  ادفع الآن
                </a>
              ) : (
                <button
                  onClick={onClose}
                  className="w-full px-5 py-2.5 text-sm font-medium text-white bg-primary-600 rounded-xl hover:bg-primary-700 transition-colors"
                >
                  تم الإطلاع
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

const HomeLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [overdueData, setOverdueData] = useState(null);
  const showChatBot = ['/', '/about', '/terms', '/faq', '/store', '/courses'].includes(location.pathname);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    // لو في تسجيل دخول جديد (توكن مختلف)، نمسح كل الـ dismissed flags
    const storedToken = sessionStorage.getItem('overdue_token_hash');
    if (storedToken !== token) {
      Object.keys(sessionStorage)
        .filter(k => k.startsWith('overdue_dismissed_'))
        .forEach(k => sessionStorage.removeItem(k));
      sessionStorage.setItem('overdue_token_hash', token);
    }

    // لو المستخدم أصلاً في صفحة التقسيط، ما نظهرش المودال
    if (location.pathname.startsWith('/installment-details/')) return;

    ordersApi.checkOverdue()
      .then(data => {
        // الممنوعين لازم يشوفوا التنوية حتى لو ضغطوا قفل قبل كدة
        if (data.blocked) {
          setOverdueData(data);
        } else if (data.has_overdue) {
          // أصحاب فترة السماح: تظهر مرة وحدة بالسشن لكل طلب
          const dismissedKey = `overdue_dismissed_${data.order_id}`;
          if (sessionStorage.getItem(dismissedKey) !== 'true') {
            setOverdueData(data);
          }
        }
      })
      .catch(() => {});
  }, []);

  const handleCloseModal = () => {
    if (overdueData?.order_id) {
      sessionStorage.setItem(`overdue_dismissed_${overdueData.order_id}`, 'true');
    }
    setOverdueData(null);
  };

  return (
    <div className="home-layout">
      <Navbar />
      <main style={{ 
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px',
        flex: 1
      }}>
        <Outlet />
      </main>
      {showChatBot && <ChatBot />}
      <Footer darkMode={true} />

      {overdueData && (
        <OverdueModal data={overdueData} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default HomeLayout;
